var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"viewContainer"},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center my-10 py-10"},[_c('h1',{staticClass:"display-4 my-10"},[_vm._v("Page not found")]),_c('h2',{staticClass:"title my-10"},[_vm._v("We couldn't find the page you're looking for.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }